import React from "react";
import "../CSS/nav.css";
import { IoIosMenu } from "react-icons/io";
import { NavLink } from "react-router-dom";
import { IoPerson } from "react-icons/io5";

export const Navbar = (props) => {
  const iconStyle = {
    fontSize: "2rem",
  };

  return (
    <div className="main-nav-container">
      <div className="navbar">
        <div className="side-bar-icon" onClick={props.onClick}>
          <IoIosMenu className="nav-icon" style={iconStyle} />
        </div>
        <h1 className="Admin-bar">
          <NavLink className={"main-link"} to="/">
            Welcome Admin
          </NavLink>
        </h1>
        <div className="Login-icon">
          <IoPerson style={iconStyle} />
        </div>
      </div>
    </div>
  );
};
